module.exports = __webpack_public_path__ + "img/cool-down.85ea9483.jpg";